import { render, staticRenderFns } from "./comm-validation-dialog.vue?vue&type=template&id=482c0707&scoped=true"
import script from "./comm-validation-dialog.vue?vue&type=script&lang=js"
export * from "./comm-validation-dialog.vue?vue&type=script&lang=js"
import style0 from "./comm-validation-dialog.vue?vue&type=style&index=0&id=482c0707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c0707",
  null
  
)

export default component.exports